import { US_STATES } from "@outschool/business-rules";
import { IntegrationCategory, useTrackEvent } from "@outschool/ui-analytics";
import {
  useSelfElectedStateFundingProgram,
  useSession,
} from "@outschool/ui-auth";
import Cookies from "js-cookie";
import React from "react";

export default function PublicFundingSessionBridge() {
  const { currentUser, esaSessionData } = useSession();
  const { setSelfElectedStateFundingProgram } =
    useSelfElectedStateFundingProgram();
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);

  // Preserve funding context for ClassWallet sessions after the bottom banner is removed.
  React.useEffect(() => {
    const stateName = US_STATES.find(
      state => state.abbreviation === esaSessionData?.shipping?.state,
    )?.name;
    if (!currentUser && esaSessionData && stateName) {
      setSelfElectedStateFundingProgram({
        hasRejectedStateFundingQuestions: false,
        hideBanner: true,
        searchFiltersActive: true,
        stateAbbreviation: esaSessionData.shipping!.state,
        stateName,
        source: "classwallet",
        fundingOptions: {
          charter: false,
          statePortal: true,
          otherProgramName: "",
          reimbursement: false,
          selfPay: false,
          stateDebitCard: false,
          stateProgramName: "default",
        },
      });
    }
  }, [currentUser, esaSessionData, setSelfElectedStateFundingProgram]);

  React.useEffect(() => {
    if (Cookies.get("hasUsedPublicFunding")) {
      trackAdEvent("signedUpWithPublicFundingOptions", {
        hasUsedPublicFunding: true,
      });
      Cookies.remove("hasUsedPublicFunding");
    }
  }, [trackAdEvent]);

  return null;
}
